import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './grace-period-modal.magic.css.js';
import script from './grace-period-modal.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grace-period-modal",attrs:{"part":"grace-period-modal","data-v-test-id":"grace-period-modal"}},[_c('div',{staticClass:"counter",attrs:{"part":"counter","data-v-test-id":"grace-period-counter"}},[_c('span',{staticClass:"text text--digit",attrs:{"part":"text text--digit"}},[_vm._v("\n            "+_vm._s(_vm.digitOne)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"text text--digit",attrs:{"part":"text text--digit"}},[_vm._v("\n            "+_vm._s(_vm.digitTwo)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"text text--large",attrs:{"part":"text text--large"},domProps:{"innerHTML":_vm._s(_vm.$t('sow-countdown-prompt.counter.days'))}})]),_vm._v(" "),_c('magic-ui-text',{staticClass:"text text--description",attrs:{"tag":"p","part":"text","data-v-test-id":"grace-period-modal-text","content":_vm.$t('grace-period-modal.description')}}),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-button',{staticClass:"button",attrs:{"wide":"","variant":"primary","part":"button","data-v-test-id":"grace-period-verified-button"},domProps:{"innerHTML":_vm._s(_vm.$t('grace-period-verified-modal.button'))},on:{"click":function($event){return _vm.verify()}}}),_vm._v(" "),_c('magic-ui-link',{staticClass:"link",attrs:{"part":"link","data-v-test-id":"grace-period-remind-button"},on:{"click":function($event){return _vm.close()}}},[_vm._v("\n            "+_vm._s(_vm.$t('grace-period-remind-modal.button'))+"\n        ")])],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5c439a92_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5c439a92";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
